import { countGoalTiers } from './trainingGoalTiers';

const MIN_INTERESTS_LEN = 20;
const MIN_PHYSICAL_STATE_LEN = 10;

export function listOnboardingProfileMissing(formData) {
  const missing = [];
  if (!formData) return ['perfil'];

  const interests = String(formData.trainingInterests || '').trim();
  if (interests.length < MIN_INTERESTS_LEN) {
    missing.push(`interesses (mín. ${MIN_INTERESTS_LEN} caracteres)`);
  }

  const tierCount = countGoalTiers(formData.trainingGoalTiers);
  const slugCount = Array.isArray(formData.trainingGoalSlugs) ? formData.trainingGoalSlugs.length : 0;
  if (tierCount < 1 && slugCount < 1) {
    missing.push('pelo menos 1 objetivo');
  }

  const physical = String(formData.physicalState || '').trim();
  if (physical.length < MIN_PHYSICAL_STATE_LEN) {
    missing.push(`estado físico (mín. ${MIN_PHYSICAL_STATE_LEN} caracteres)`);
  }

  const h = parseFloat(formData.heightCm);
  const w = parseFloat(formData.weightKg);
  if (!Number.isFinite(h) || h <= 0 || !Number.isFinite(w) || w <= 0) {
    missing.push('altura e peso');
  }

  return missing;
}

export function isOnboardingProfileComplete(formData) {
  return listOnboardingProfileMissing(formData).length === 0;
}

export function listOnboardingProfileRecommendations(formData) {
  const recs = [];
  if (!formData) return recs;

  const base = String(formData.previousTrainingBase || '').trim();
  if (!base) {
    recs.push('histórico de treinos (melhora linha base: no prompt)');
  }

  const tp = formData.trainingProfile || {};
  const days = tp.schedulePattern?.daysPerWeek;
  const mins = tp.schedulePattern?.minutesPerSession;
  if (!Number.isFinite(days) || days <= 0 || !Number.isFinite(mins) || mins <= 0) {
    recs.push('agenda semanal (dias/min por sessão no fingerprint)');
  }

  if (!formData.birthDate) {
    recs.push('data de nascimento (idade no fingerprint)');
  }

  const lims = (tp.limitations || []).filter((l) => l && l !== 'none');
  if (!lims.length) {
    recs.push('limitações físicas (refina DNA HARD: no prompt)');
  }

  return recs;
}

export function goalCountForChecklist(formData) {
  const n = countGoalTiers(formData?.trainingGoalTiers);
  if (n > 0) return n;
  return Array.isArray(formData?.trainingGoalSlugs) ? formData.trainingGoalSlugs.length : 0;
}
